// extracted by mini-css-extract-plugin
module.exports = {"dataCell":"SystemsTable_dataCell__78m_D","headerCell":"SystemsTable_headerCell__25rY2","ellipseCell":"SystemsTable_ellipseCell__3zUbW","tooltip":"SystemsTable_tooltip__18Wi_"};